module.exports = __webpack_public_path__ + "img/other.f3969556.svg";